import { useTranslation } from 'react-i18next'

import { Divider } from '../../../Divider'
import { ProfileDateWithUserWidgetItem } from '../../ProfileDateWithUserWidgetItem'

import * as styles from './ProfileCreatedWidgetContent.module.css'

function ProfileCreatedWidgetContent({
  canViewCreatedBy,
  canViewUpdatedBy,
  className = styles.ProfileCreatedWidgetContent,
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <ProfileDateWithUserWidgetItem
        canViewUser={canViewCreatedBy}
        className={styles.item}
        date={createdAt}
        dateLabel={t('Widget.CreatedOnTitleKey')}
        user={createdBy}
        userLabel={t('Widget.CreatedByTitleKey')}
      />
      {updatedAt ? (
        <>
          <Divider className={styles.divider} />
          <ProfileDateWithUserWidgetItem
            canViewUser={canViewUpdatedBy}
            className={styles.item}
            date={updatedAt}
            dateLabel={t('Widget.UpdatedOnTitleKey')}
            user={updatedBy}
            userLabel={t('Widget.UpdatedByTitleKey')}
          />
        </>
      ) : null}
    </div>
  )
}

export default ProfileCreatedWidgetContent
